<template>
  <div class="studyHeader">
      <div class="left flex-start" @click="goto" v-if="studyData.subject">
          <div class="cancel fs-12 tc-gray el-icon-arrow-left tc pointer"></div>
          <p class="name">{{studyData.subject}}</p>
      </div>
      <div class="right">
            <p @click="startpopu" v-if="studyData.iscommen == 0">评价课程</p>
             <el-popover
                placement="bottom"
                width="148"
                trigger="hover">
                <p slot="reference">手机学习</p>
                <div id="qrcode" ></div>
                <!-- <img style="" src="" alt=""> -->
                <p style="text-align: center; font-size: 14px; color:#333">手机观看更方便</p>
            </el-popover>
            <el-popover v-if="studyData.hostinfo && studyData.hostinfo.serviceqrurl"
                placement="bottom" 
                width="148"
                trigger="hover">
                <p slot="reference">咨询老师</p>
                <img style="width: 108px; height: 108px; background: #ccc; display: blocl; margin:auto; margin-bottom: 10px;" v-lazy="studyData.hostinfo.serviceqrurl" :alt="studyData.hostinfo.hostname">
                <p style="text-align: center; font-size: 14px; color:#333">{{studyData.hostinfo.hostname}}</p>
            </el-popover>
            <p @click="justOptype"><template v-if="this.studyData.isfavorite == 1">取消收藏</template><template v-else>收藏课程</template></p>
      </div>
      <Evaluate ref="evaluate"></Evaluate>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import Evaluate from './Evaluate'
import {uploadCourseFavorite} from 'api/public'
import QRCode  from "qrcodejs2"
export default {
    name: 'studyHeader',
    props: ['studyData'],
    data() {
        return {
            courseid: this.$route.query.courseid,
        }
    },
    mounted() {
        this.qRCode()
    },
    methods: {
        goto() { // 前往详情
            this.$router.push({name: 'CourseDetails', query: {cid: this.$route.query.courseid}})
        },
        qRCode() { // 二维码生成
            // console.log(window.location.origin+'/m/courseView?cid='+this.$route.query.courseid)
            new QRCode('qrcode', {
                width: 108,
                height: 108,        // 高度
                text: window.location.origin+'/m/courseView?cid='+this.$route.query.courseid,   // 二维码内容
                // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                // background: '#f0f',   // 背景色
                  // foreground: '#ff0'    // 前景色
            })
            
        },
        justOptype() {
             if (this.studyData.isfavorite == 1) {
                 this.$confirm('是否需要取消收藏该课程, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        this.uploadCourseFavorite(0)
                    }).catch(() => {
                   
                });
            } else {
                this.uploadCourseFavorite(1)
            }
        },
        uploadCourseFavorite(optype) {
            this.setLoading(true)
            uploadCourseFavorite({
                data: {optype: optype, courseid: this.courseid, kmctype: 7},
                success: data => {
                    if (data.code == '000') {
                        if (optype == 0) {
                            this.$message.success('已取消收藏')
                        } else {
                            this.$message.success('收藏成功')
                        }
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.setLoading(false)

                    this.$nextTick(() => {
                        this.studyData.isfavorite = optype
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        startpopu() {
            this.$refs.evaluate.startPopu()
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Evaluate
    }
    
}
</script>

<style lang="scss" type="text/scss" scope> 
#qrcode {
    display: block;
    width: 108px; 
     // height: 108px; 
    background: #ccc; 
    margin:auto; 
    margin-bottom: 10px;
        
}
.studyHeader {
    padding: 0 30px;
    height: 50px;
    background: #323232;
    .cancel{
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        background: #D8D8D8;
        margin-right: 10px;
        &:hover{
            color: #409EFF;
        }
    }
    p {
        color: #E5E5E5;
    }
    .left {
        float: left;
        .name {
            line-height: 50px;
            font-size: 14px;
            cursor: pointer;
        }
    }
    .right {
        float: right;
        p {
            margin-left: 30px;
            cursor: pointer;
            float: left;
            line-height: 50px;
        }
    }
}
</style>